import P from 'bluebird';
import $ from 'jquery';
const $window = $(window);

export default (imageUrl) => {
    return new P((resolve, reject) => {
        const timeout = setTimeout(function () {
            resolve(true);
        }, 1000);
        const image = new Image();
        image.on('load', () => {
            clearTimeout(timeout);
            resolve(true);
        });

        image.on('error', (err) => {
            clearTimeout(timeout);
            reject(err);
        });

        image.src = imageUrl;
    });
};

export function iframeLoadPromise(iframe) {
    return new P((resolve) => {
        const $iframe = $(iframe);
        const timeout = setTimeout(function () {
            resolve(true);
        }, 1000);

        $iframe.on('load', () => {
            clearTimeout(timeout);
            resolve(true);
        });

        $iframe.on('error', (err) => {
            clearTimeout(timeout);
            resolve(err);
        });
    });
}

export function loadIframes($selector) {
    let iframes = $('.article-content').find('iframe');
    if ($selector) {
        iframes = $selector.find('iframe');
    }
    return P.all(iframes.toArray().map(function (iframe) {
        return iframeLoadPromise(iframe);
    })).then(function () {
        $window.trigger('fc:article-content:resize');
    });
}
